"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = exports.ApiRequest = void 0;
const Request_1 = __importDefault(require("./Request"));
/**
 * Gestore Api
 *
 * @export
 * @class Api
 * @extends {Request}
 */
class ApiRequest extends Request_1.default {
    /**
     * @memberof Api
     */
    constructor() {
        super(getenv('REACT_APP_SERVER_URL'));
    }
    /**
     * Setta i middleware prima di effettuare una richiesta asincrona
     *
     * @param {*} middlewares
     * @param {() => Promise<any>} closure
     * @param {*} [data=[]]
     * @returns {Promise<any>}
     * @memberof Api
     */
    middleware(middlewares, closure, data = []) {
        middlewares = Array.isArray(middlewares) ? middlewares : [middlewares];
        data = Array.isArray(middlewares) ? data : [data];
        return Promise.all(middlewares.map((middleware, index) => new middleware(data[index]))).then(closure);
    }
}
exports.ApiRequest = ApiRequest;
const Api = new ApiRequest();
exports.Api = Api;
